import { Box } from "@mui/joy";
import React from "react";
import { centrado } from "../utils/Estilos";
import nosotros from "../assets/banner/nosotrosp.jpg";
import { Grid2, Typography } from "@mui/material";
import { Helmet } from "react-helmet";

export const Reembolso = () => {
  return (
    <Box sx={{ ...centrado, width: "100%", flexWrap: "wrap" }}>
      <Helmet>
        <title>
          {"Publimed Store - Política de Reembolsos y Cancelaciones"}
        </title>
      </Helmet>
      <Box
        sx={{
          backgroundImage: "url(" + nosotros + ")",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "400px",
          width: "100%",
        }}
      />
      <Grid2 container sx={{ width: "80%", ...centrado }} py={2}>
        <Grid2 size={{ xs: 12, md: 10 }} sx={{ padding: "20px" }}>
          <Typography variant="h5" fontWeight={"bold"} color="primary" pt={5}>
            Refund and Cancellation Policy
          </Typography>
          <Typography variant="h6" pt={5}>
            At Publimed, we strive to provide the highest quality in our medical
            education services.
          </Typography>
          <Typography variant="h6" pt={2}>
            Digital Products and Services: Due to the nature of our digital
            services (exam simulators and educational access), all sales are
            final. Once the user has been granted access to the chosen service
            or digital platform, no refunds will be issued.
          </Typography>
          <Typography variant="h6" pt={2}>
            Delivery of Service: Access to digital services is typically
            immediate upon payment via credit/debit card. For payments made via
            bank transfer, a manual verification process of up to 24 hours may
            apply before access is granted.
          </Typography>
          <Typography variant="h6" pt={2}>
            Contact Us: If you experience any technical issues accessing our
            services, please contact our international support line at
            +593992083374 or email ventas@publimed.net.
          </Typography>
        </Grid2>
      </Grid2>
    </Box>
  );
};
